import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, ValidationErrors, Validators } from '@angular/forms';
import { ConfirmationService, } from 'primeng/api';
import { CoreService } from '../core/_services/core.services';
import { AlertasService } from '../core/_services/alerta.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';


@Component({
  selector: 'app-asociacion-ficha',
  templateUrl: './asociacion-ficha.component.html',
  styleUrls: ['./asociacion-ficha.component.scss']
})
export class AsociacionFichaComponent implements OnInit {

  @Input() fichaActual: any;
  //formulario
  formBuilder: FormBuilder;
  formulario: FormGroup;
  mostrarFormulario: Boolean = false;
  registroNuevo: Boolean = false;
  submitted: Boolean = false;
  botonGuardar: Boolean = false;
  botonActualizar: Boolean = false;
  mostrarEstado: Boolean = false;
  cargandoListaAsociacion: boolean = true;
  idAsociacion: any;

  //lista de registros
  registrosLista: any = [];
  listaPrueba: any = [];
  listaEstado: any = [];
  listaPruebaFiltro: any = [];
  columnas: any = [];
  totalRecords = 0;

  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    private route: ActivatedRoute,
    public confirmationService: ConfirmationService,
    private breadCrumbService: AppBreadcrumbService
  ) {
    this.formBuilder = new FormBuilder();

    this.listaEstado = [
      { descripcion: 'ACTIVO', id: 'ACTIVO' },
      { descripcion: 'INACTIVO', id: 'INACTIVO' }
    ];

    this.listaPruebaFiltro = [
      { descripcion: 'SI', id: 'SI' },
      { descripcion: 'NO', id: 'NO' }
    ];

    this.breadCrumbService.setItems([
      { label: 'Ficha' }
    ]);
  }

  ngOnInit(): void {
    this.totalRecords = 0;
    this.columnas = [
      { field: 'descripcion', header: 'Nombre Prueba' },
      { field: 'porcentaje_minimo', header: '% Mínimo' },
      { field: 'prueba_filtro', header: 'Prueba Filtro' },
      { field: 'estado', header: 'Estado' }
    ];

    this.formulario = this.formBuilder.group({
      prueba: ['', Validators.required],
      porcMin: ['', Validators.required],
      pruebaFiltro: ['', Validators.required],
      estado: ['', Validators.required],
      estado1: [''],
    });
    this.getListado();
    this.getListaPrueba();
  }

  /**
   * Listados
   */
   getListado() {
    let params = {
      ficha_id: this.fichaActual
    }
    this.cargandoListaAsociacion = true;
    this.coreService.getWithParams('/index-pruebas-asociadas', params).subscribe(
      (res: any[]) => {
        this.registrosLista = res;
        this.totalRecords = this.registrosLista.length;
        this.cargandoListaAsociacion = false;
      },
      (err: any) => {
        this.cargandoListaAsociacion = false;
        console.log(err);
      }
    )
  }

  getListaPrueba() {
    this.coreService.get('/listas/tipoPrueba').subscribe(
      (res: any[]) => {
        this.listaPrueba = res;
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  /**
   * Acciones
   */
   prepararNuevo() {
    this.mostrarFormulario = true;
    this.registroNuevo = true;
    this.formulario.reset();
    this.botonGuardar = true;
    this.botonActualizar = false;
    this.mostrarEstado = false;
    this.formulario.controls['estado'].setValue('ACTIVO');
    this.formulario.controls['estado1'].setValue('ACTIVO');
  }

  volver() {
    this.mostrarFormulario = false;
    this.submitted = false;
  }

  /**
   * Crear
   */
  guardarAsociacion() {
    var dat = this.formulario.valid;
    if (dat) {
      this.confirmationService.confirm({
        message: '¿Desea guardar esta asociación?',
        accept: () => {
          this.submitted = true;
          this.postGuardarAsociacion();
          this.mostrarFormulario = false;
        }
      });
    }else{
      this.formulario.markAllAsTouched();
    }
  }

  postGuardarAsociacion() {
    let params = {
      ficha_id: this.fichaActual,
      prueba_id: this.formulario.value.prueba.id,
      porc_min: this.formulario.value.porcMin,
      prueba_filtro: this.formulario.value.pruebaFiltro.id
    };

    this.coreService.post('/guardar-prueba-asociada', params).subscribe(
      (res: any) => {
        if(res.success){
          this.msj.info('Asociación guardada correctamente');
          this.getListado();
        } else {
          this.msj.error(res.mensaje);
        }

      },
      (err: any) => {
        if (err.errors.error !== undefined && err.errors.error !== null) {
          for (let index = 0; index < err.errors.error.length; index++) {
            this.msj.error(err.errors.error[index]);
          }
        }
      }
    )
  }

  /**
   * Actualizar
   */
   editarAsociacion(data) {
    this.idAsociacion = data.id;
    this.registroNuevo = false;
    this.mostrarFormulario = true;
    this.botonGuardar = false;
    this.botonActualizar = true;
    this.mostrarEstado = true;

    this.formulario.controls['prueba'].setValue(data.descripcion);
    this.formulario.controls['porcMin'].setValue(data.porcentaje_minimo);
    this.formulario.controls['pruebaFiltro'].setValue(this.cargarListaPruebaFiltro(this.listaPruebaFiltro, data.prueba_filtro));
    this.formulario.controls['estado'].setValue(this.cargarListaEstado(this.listaEstado, data.estado));
  }  

  cargarListaPrueba(iLista, valor) {
    if (iLista !== undefined && iLista != null) {
      for (let i = 0; i < iLista.length; i++) {
        if (iLista[i].id === valor) {
          return iLista[i];
        }
      }
    }
  }

  cargarListaPruebaFiltro(iLista, valor) {
    if (iLista !== undefined && iLista != null) {
      for (let i = 0; i < iLista.length; i++) {
        if (iLista[i].id === valor) {
          return iLista[i];
        }
      }
    }
  }

  cargarListaEstado(iLista, valor) {
    if (iLista !== undefined && iLista != null) {
      for (let i = 0; i < iLista.length; i++) {
        if (iLista[i].id === valor) {
          return iLista[i];
        }
      }
    }
  }

  actualizarAsociacion() {
    let dat = this.formulario.valid;
    if (dat) {
      this.confirmationService.confirm({
        message: '¿Desea actualizar esta asociación?',
        accept: () => {
          this.formulario.markAllAsTouched();
          this.submitted = true;
          this.putActualizarAsociacion();
          this.mostrarFormulario = false;
        }
      });
    } else {
      this.formulario.markAllAsTouched();
    }
  }

  putActualizarAsociacion() {
    let params = {
      id: this.idAsociacion,
      porc_min: this.formulario.value.porcMin,
      prueba_filtro: this.formulario.value.pruebaFiltro.id,
      estado: this.formulario.value.estado.id
    }

    this.coreService.put('/editar-prueba-asociada', params).subscribe(
      (res: any) => {
        if(res.success){
          this.msj.info('Asociación actualizada exitosamente');
          this.getListado();
        } else {
          this.msj.error(res.mensaje);
        }
      },

      (err: any) => {
        if (err.errors.error !== undefined && err.errors.error !== null) {
          for (let index = 0; index < err.errors.error.length; index++) {
            this.msj.error(err.errors.error[index]);
          }
        }
      }
    )
  }

  /**
   * Validaciones
   */
   soloNumerosDecimales(e) {
    if (e.code !== 'Tab') {
      const tecla = (document.all) ? e.keyCode : e.which; // 2
      if (tecla === 8) return true; // 3
      let patron = /[\d.]/; // 4
      const te = String.fromCharCode(tecla); // 5
      return patron.test(te); // 6
    }
  }
  
  campoNoValido(campo: any) {
    return this.formulario.get(campo)?.invalid && this.formulario.get(campo)?.touched;
  }
}